"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.legacyAriaLabelSDKFactory = void 0;
const assert_1 = require("../../assert");
const reporters_1 = require("../../reporters");
const constants_1 = require("./constants");
const legacyAriaLabelSDKFactory = ({ setProps, props }) => ({
    get ariaLabel() {
        return props.ariaLabel;
    },
    set ariaLabel(label) {
        if (!assert_1.assert.isString(label)) {
            reporters_1.reportError(constants_1.ErrorMessages.ARIA_LABEL_NOT_STRING);
            return;
        }
        if (!label.length) {
            reporters_1.reportError(constants_1.ErrorMessages.ARIA_LABEL_EMPTY_STRING);
            return;
        }
        setProps({ ariaLabel: label });
    },
    remove(attribute) {
        if (!constants_1.REMOVABLE_ATTRIBUTES.includes(attribute)) {
            reporters_1.reportError(constants_1.ErrorMessages.REMOVING_MISSING_ATTRIBUTE);
            return;
        }
        setProps({ [attribute]: undefined });
    },
});
exports.legacyAriaLabelSDKFactory = legacyAriaLabelSDKFactory;
//# sourceMappingURL=legacyAriaLabelSDKFactory.js.map